<template>
  <ux-form
    ref="form"
    width="470px"
    :data="formData"
    :rules="rules"
    :colon="true"
    label-width="120px"
  >
    <div class="warning-box">
      <i class="el-icon-warning"></i>
      <div>
        <strong>{{ $t('HT.subordinate.quota.riskWarning') }}</strong>
        <p>{{ $t('HT.subordinate.quota.revokeWarning') }}</p>
      </div>
    </div>
    <div class="account-panel">
      <div>
        <span>{{ $t('HT.subordinate.quota.accountName') }}</span
        ><strong>{{ account.name || account.account_name }}</strong>
      </div>
      <div>
        <span>{{ $t('HT.subordinate.quota.productName') }}</span
        ><strong>{{ revokeInfo.product_name || '—' }}</strong>
      </div>
      <div>
        <span>{{ $t('HT.subordinate.quota.currentQuota') }}</span
        ><strong>{{
          $t('HT.subordinate.quota.quotaValue', {
            quota: formatQuota(revokeInfo.allocated_quota)
          })
        }}</strong>
      </div>
      <div>
        <span>{{ $t('HT.subordinate.quota.used') }}</span
        ><strong>{{
          $t('HT.subordinate.quota.quotaValue', {
            quota: formatQuota(revokeInfo.used_quota)
          })
        }}</strong>
      </div>
      <div>
        <span>{{ $t('HT.subordinate.quota.revocableAmount') }}</span
        ><strong class="orange-text">{{
          $t('HT.subordinate.quota.quotaValue', { quota: formatQuota(remaining) })
        }}</strong>
      </div>
    </div>
    <ux-form-item :label="$t('HT.subordinate.quota.revokeAmount')" required prop="amount">
      <ux-input
        v-model="formData.amount"
        type="number"
        :placeholder="$t('HT.subordinate.quota.revokeAmountPlaceholder')"
      ></ux-input>
      <p class="form-hint">
        {{
          $t('HT.subordinate.quota.revokeRemainingHint', {
            quota: formatQuota(withdrawRemaining)
          })
        }}
      </p>
    </ux-form-item>
    <ux-form-item :label="$t('HT.subordinate.quota.revokeReason')" required prop="reason">
      <ux-select
        v-model="formData.reason"
        :options="reasons"
        :props="{ label: 'description', value: 'code' }"
        :placeholder="$t('HT.subordinate.quota.revokeReasonPlaceholder')"
      ></ux-select>
    </ux-form-item>
    <ux-form-item :label="$t('HT.subordinate.common.remark')" prop="remark">
      <ux-input
        v-model="formData.remark"
        type="textarea"
        :maxlength="100"
        :placeholder="$t('HT.subordinate.common.optional')"
      ></ux-input>
    </ux-form-item>
  </ux-form>
</template>

<script>
// 接口配额单位为次，页面表单单位为万次
const QUOTA_UNIT = 10000;

export default {
  name: 'QuotaWithdrawModal',
  props: {
    // 待撤回配额的账号信息
    account: { type: Object, required: true },
    // 接口返回的配额撤回详情
    revokeInfo: { type: Object, required: true }
  },
  data() {
    const validateAmount = (rule, value, callback) => {
      const amount = Number(value);
      if (!Number.isFinite(amount) || amount <= 0)
        return callback(new Error(this.$t('HT.subordinate.quota.revokeAmountPositive')));
      if (amount * QUOTA_UNIT > this.remaining)
        return callback(new Error(this.$t('HT.subordinate.quota.revokeAmountExceeded')));
      callback();
    };
    return {
      formData: { amount: '', reason: '', remark: '' },
      // 接口返回的配额撤回原因字典
      reasons: [],
      rules: {
        amount: [{ required: true, validator: validateAmount, trigger: 'blur' }],
        reason: [
          {
            required: true,
            message: this.$t('HT.subordinate.quota.revokeReasonPlaceholder'),
            trigger: 'change'
          }
        ],
        remark: [
          {
            max: 100,
            message: this.$t('HT.subordinate.common.remarkMaxLength'),
            trigger: 'blur'
          }
        ]
      }
    };
  },
  created() {
    this.getRevokeReasons();
  },
  computed: {
    remaining() {
      return Math.max(Number(this.revokeInfo.remaining_quota || 0), 0);
    },
    withdrawRemaining() {
      return Math.max(this.remaining - Number(this.formData.amount || 0) * QUOTA_UNIT, 0);
    }
  },
  methods: {
    // 获取配额撤回原因字典
    getRevokeReasons() {
      this.$api.accountQuota.getRevokeReasons().then((res) => {
        if (res.code == 10000) {
          this.reasons = Array.isArray(res.data) ? res.data : [];
        }
      });
    },
    // 格式化弹窗中的配额提示
    formatQuota(value) {
      return (Number(value || 0) / QUOTA_UNIT).toFixed(2);
    }
  }
};
</script>

<style lang="scss" scoped>
.warning-box {
  display: flex;
  padding: 12px 14px;
  margin-bottom: 18px;
  border: 1px solid #ffe3b2;
  border-radius: 4px;
  background: #fff9ed;
  color: #fa8c16;
  font-size: 13px;
  i {
    margin: 2px 8px 0 0;
    font-size: 16px;
  }
  strong {
    font-weight: 500;
  }
  p {
    margin: 6px 0 0;
    color: #a97836;
    font-size: 12px;
    line-height: 18px;
  }
}
.account-panel {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 12px 18px;
  padding: 14px 18px;
  margin-bottom: 18px;
  border-radius: 4px;
  background: #f7f9fc;
  font-size: 13px;
  div {
    display: flex;
    justify-content: space-between;
  }
  span {
    color: #929baa;
  }
  strong {
    font-weight: 500;
  }
}
.orange-text {
  color: #fa8c16;
}
.form-hint {
  margin: 4px 0 0;
  color: #929baa;
  font-size: 12px;
  line-height: 18px;
}
</style>
